import React, { useState, useEffect } from "react";
import { MessageCircle, Phone } from "lucide-react";
import { useContent } from "../contexts/ContentContext";

export default function FloatingActions({ onEnquire }) {
  const { content } = useContent();
  const { company } = content;
  const [show, setShow] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setShow(true), 400);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className={`fixed bottom-5 right-5 z-40 flex flex-col items-end gap-3 transition-all ${show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
      <a
        href={`https://wa.me/${company.whatsapp.replace(/[^0-9]/g, "")}`}
        target="_blank"
        rel="noreferrer"
        className="group w-12 h-12 rounded-full bg-emerald-500 hover:bg-emerald-600 shadow-lg flex items-center justify-center transition-transform hover:scale-110"
        aria-label="WhatsApp"
      >
        <svg viewBox="0 0 24 24" className="w-6 h-6 fill-white"><path d="M20.52 3.48A11.94 11.94 0 0 0 12.07 0C5.52 0 .21 5.31.21 11.85a11.78 11.78 0 0 0 1.59 5.94L0 24l6.4-1.68a11.83 11.83 0 0 0 5.66 1.44h.01c6.55 0 11.86-5.31 11.86-11.85a11.82 11.82 0 0 0-3.41-8.43zM12.07 21.5a9.6 9.6 0 0 1-4.89-1.34l-.35-.21-3.8 1 1.01-3.7-.23-.38a9.62 9.62 0 1 1 8.26 4.63zm5.27-7.18c-.29-.14-1.7-.84-1.97-.94-.26-.1-.45-.14-.65.14-.19.29-.74.94-.91 1.13-.17.19-.34.22-.62.07a7.83 7.83 0 0 1-2.3-1.42 8.7 8.7 0 0 1-1.6-1.99c-.17-.29 0-.45.13-.59.13-.13.29-.34.43-.51.14-.17.19-.29.29-.48.1-.19.05-.36-.02-.5-.07-.14-.65-1.56-.89-2.13-.23-.56-.47-.49-.65-.5h-.55a1.07 1.07 0 0 0-.77.36 3.23 3.23 0 0 0-1 2.4c0 1.42 1.04 2.79 1.18 2.98.14.19 2.04 3.12 4.95 4.38.69.3 1.23.48 1.65.62.69.22 1.32.19 1.82.12.55-.08 1.7-.69 1.94-1.36.24-.67.24-1.24.17-1.36-.08-.12-.27-.19-.55-.34z"/></svg>
      </a>
      <a
        href={`tel:${company.phone}`}
        className="w-12 h-12 rounded-full bg-[#0a4f47] hover:bg-[#0e6e63] shadow-lg flex items-center justify-center transition-transform hover:scale-110"
        aria-label="Call"
      >
        <Phone className="w-5 h-5 text-white" />
      </a>
      <button
        onClick={onEnquire}
        className="w-12 h-12 rounded-full bg-orange-500 hover:bg-orange-600 shadow-lg flex items-center justify-center transition-transform hover:scale-110"
        aria-label="Chat"
      >
        <MessageCircle className="w-5 h-5 text-white" />
      </button>
    </div>
  );
}
